/**
 * 
 */
const populate = response => {

    //
    response.data = response.data.map( item => {

        //
        let g_user = item,
            hr_employee = item.hr_employee

        //
        delete g_user[ 'hr_employee' ]
        delete hr_employee[ 'id' ]

        //
        return {
            ...g_user,
            ...hr_employee,
            commissionsLength: g_user.commissions.length,
            userFullName: [ hr_employee.names, hr_employee.last_name1, hr_employee.last_name2 ].join( ' ' ),
            userIsGroundSeller: g_user.is_ground_seller ? 'Si' : 'No'
        }
    })

    //
    return response    
}

//
export default populate
